module.exports = __webpack_public_path__ + "img/novo-nordisk-innovationHub_BW.57e7a483.png";